<template>
	<v-data-table
		class="task-table"
		:headers="headers"
		:items="items_local"
		:page.sync="page"
		:items-per-page="countPerpage"
		hide-default-footer
		hide-default-header
	>
		<template v-if="!$vuetify.breakpoint.smAndDown" v-slot:header="{ props: { headers } }">
			<thead>
				<tr>
					<th 
						v-for="item in headers" 
						:key="item.value" 
						class="header-th" 
						@mouseover="isHover = item.value"
						@mouseout="isHover = ''">
						<div class="header-item" v-if="item.showable">
							<div class="header-item-text" v-if="item.text.length !== 0">{{ item.text }}</div>
							<v-checkbox
								v-if="item.type === 'select'"
								:color="color"
								:value="allSelect"
								:disabled="items.length === 0"
								:indeterminate="indeterminate"
								@change="onSelectAllChange($event)"
							></v-checkbox>
							<v-tooltip top v-if="item.type === 'tooltip'">
								<template v-slot:activator="{ on, attrs }">
									<v-icon
										:color="color"
										v-bind="attrs"
										v-on="on"
										class="ml-2 icon"
									>
										mdi-information-outline
									</v-icon>
								</template>
								<span v-if="item.value === 'budget_used'">Progress is Actuals:Budget</span>
								<span v-if="item.value === 'isComplete'">Change task status to Complete</span>
							</v-tooltip>
							<div>
								<v-btn
									v-if="item.type === 'sort'" 
									icon
									class="ml-2"
									:color="isHover === item.value ? color : '#FAFAFA'"
									@click="onSort(item.value)"
								>
									<SortUpDown 
										color="#FAFAFA"
										style="width: 20px; height: 20px"
										:selected="isHover === item.value" 
										:selected_color="color"
									/>
								</v-btn>
								<v-menu v-if="item.searchable"  offset-y nudge-left="120" >
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											v-bind="attrs"
											v-on="on"
											icon
											:color="isHover === item.value ? color : '#FAFAFA'"
										>
											<ShowSearch 
												color="#FAFAFA"
												style="width: 18px; height: 18px"
												:selected="isHover === item.value" 
												:selected_color="color"
											/>
										</v-btn>
									</template>
									<div class="search-box">
										<v-text-field
											placeholder="Type to search"
											outlined
											dense
											hide-details="auto"
											color="#81CC00" 
											:value="current_key === item.value ? searchValue : ''"
											@input="searchValue = $event"
											@click.stop
										/>
										<div class="search-box-button">
											<div @click.stop="onClean()">CLEAR</div>
											<div @click="onSearch(item.value)">SEARCH</div>
										</div>
									</div>
								</v-menu>
								<v-menu v-if="item.value === 'status'" offset-y nudge-left="80" min-width="100px" :close-on-content-click="false">
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											v-if="item.type === 'filter'"
											v-bind="attrs"
											v-on="on"
											:color="isHover === item.value ? color : '#FAFAFA'"
											icon
										>
											<FirstList 
												color="#FAFAFA"
												style="width: 20px; height: 20px"
												:selected="isHover === item.value" 
												:selected_color="color"
											/>
										</v-btn>
									</template>
									<div v-for="status in statuses" :key="status.id">
										<v-checkbox
											style="background-color: #FFFFFF"
											class="filter-box mt-0 mr-2"
											v-model="selected_task_status"
											:label="status.desc"
											:value="status.id"
											:color="color"
											dense
											hide-details>
										</v-checkbox>
									</div>
								</v-menu>
							</div>
						</div>
					</th>
				</tr>
			</thead>
		</template>
		<template v-slot:body="{ items }">
			<tbody>
				<tr v-for="(item, index) in items" :key="index" @click="onRowClick(item)">
					<td v-for="(value, key) in filterItem(item)" :key="key">
						<v-checkbox
							v-if="key === 'select'"
							v-model="item.select"
							@click.native.stop
							@change="onCheckboxChange()"
							:color="color"
							:disabled="!item.job_valid"
						></v-checkbox>
						<v-btn
							v-else-if="key === 'log'"
							fab
							depressed
							x-small
							:disabled="value.status_type === status_completed_type || !item.job_valid"
							color="#82899B"
						>
							<TimeSheet color="#FFFFFF" width="20" height="20" @click="onLogTime(item)"/>
						</v-btn>
						<TaskTimerIcon v-else-if="key === 'auto'"
							class="mt-1"
							:recording="value.id === recordingTaskId"
							:status_type="item.job_valid ? value.status_type : 0" 
							:active="recordingTaskId === 0"
							@start="startRecording(value.id)"
							@stop="$emit('stop_recording')"
						/>
						<div v-else-if="key === 'title'" @click.stop style="min-width: 12vw">
							<v-row class="ma-0 px-0" justify="space-between" no-gutters>
								<v-col cols="11">
									<v-text-field
										v-if="edit_visible === item.id"
										v-model="item.title"
										:color="color"
										outlined
										hide-details
										dense
										background-color="#FFFFFF"
										clearable
										@click.stop
										@change="onUpdateName(item.id, $event)"
									>
									</v-text-field>
									<div class="py-2 px-1" :class="item.job_valid ? 'text-box-black' : ''" v-else @click.stop="onEditVisible(item)" v-html="value"></div>
								</v-col>
								<v-col cols="1">
									<v-btn icon @click="onFindTimesheet(item.id)">
										<FindTimesheet color="rgba(25, 42, 62, 0.7)" width="24" height="24" />
									</v-btn>
								</v-col>
							</v-row>
						</div>
						<div v-else-if="key === 'task_for'">
							<v-user-avatar
								v-if="value"
								size="24"
								class="mr-1"
								:code="value && formatName(value[0].DisplayName)"
								:image="value && value[0].AbookId ? `/api/addressbook/${value[0].AbookId }/image.png`: ''"
							/>
							<span v-if="value">
								{{ formatName(value[0].DisplayName) }}
								<v-menu open-on-hover offset-y>
									<template v-slot:activator="{ on, attrs }">
										<v-icon 
											v-if="value && value.length > 1"
											v-bind="attrs"
											v-on="on">
											mdi-dots-horizontal
										</v-icon>
									</template>
									<v-list dense v-if="value.length > 1">
										<v-list-item
											v-for="(item, index) in value.filter((v, i) => {return i !== 0})"
											:key="index"
										>
											<v-user-avatar
												size="24"
												class="mr-2"
												:code="formatName(item.DisplayName)"
												:image="item.AbookId ? `/api/addressbook/${item.AbookId }/image.png`: ''"
											/>
											<span class="user-name-text">{{ formatName(item.DisplayName) }}</span>
										</v-list-item>
									</v-list>
								</v-menu>
							</span>
						</div>
						<div v-else-if="key === 'start_date'" :class="item.isSuggested ?'date-color-suggest':'' ">{{ formatDate(value) }}</div>
						<div v-else-if="key === 'end_date'" :class="item.isSuggested ?'date-color-suggest':'' ">{{ formatDate(value) }}</div>
						<v-select
							style="width: 10vw"
							v-else-if="key === 'status'"
							:value="value"
							:color="color"
							:items="getStatuses(item.id)"
							item-text="desc"
							item-value="id"
							item-color="success"
							item-disabled="disable"
							:background-color="item.job_valid && item.other_edit ? value.color: 'rgba(0,0,0,.12)'"
							dense
							outlined
							hide-details
							return-object
							:disabled="!item.job_valid || !item.other_edit"
							@click.stop
							@change="onStatusChange($event, item.id)"
						>
							<template v-slot:append>
								<v-icon :style="`color: ${item.job_valid && item.other_edit ? formatColor(value.color):'rgba(0,0,0,.26)'}`">mdi-chevron-down</v-icon>
							</template>
							<template v-slot:selection="{ item, disabled }">
								<span :style="`color: ${!disabled ? formatColor(value.color):'rgba(0,0,0,.26)'}`">{{ item.desc }}</span>
							</template>
							<template v-slot:item="{item, on}">
								<v-list-item v-on="on" dense>
									<v-badge
										:color="item.color"
										left
										inline
									>
										<span class="ml-1 task-calendar-item-name">{{ item.desc }}</span>
									</v-badge>					
								</v-list-item>
							</template>
						</v-select>
						<div v-else-if="key === 'budget_used'">
							<v-icon :color="value > 100 ? 'red': (value > 80 ? 'yellow' : color)  ">mdi-checkbox-blank-circle</v-icon>
							<span>{{ value }}%</span>
						</div>
						<div v-else-if="key === 'budget' || key === 'actual' || key === 'remaining' || key === 'phase'">
							<span>{{ value }}</span>
						</div>
						<div v-else-if="key === 'phase'"  style="width: 12vw">
							<span>{{ value }}</span>
						</div>
						<div v-else-if="key === 'priority'">
							<v-rating
								:value="value"
								:color="color"
								:background-color="color"
								length="5"
								size="24"
								dense
								readonly
							></v-rating>
						</div>
						<div v-else-if="key === 'isComplete'">
							<div v-if="value" class="white--text text-capitalize px-3 py-1" style="background-color:#82899B; border-radius: 4px; height: 28px; width: 80px;"> 
								<v-icon small class="mr-1 white--text">mdi-check</v-icon>
								<span style="font-size: 12px;font-weight: 500">Done</span>
							</div>
							<v-btn v-else small depressed :color="color" :disabled="!item.job_valid || !item.other_edit" class="white--text text-capitalize" @click.stop="onCompleted(item)">Complete</v-btn>
						</div>
						<div v-else-if="key === 'display' || key === 'days'" v-html="value" :style="key === 'display' ? 'width: 12vw':''"></div>
					</td>
				</tr>
			</tbody>
		</template>
		<template v-slot:footer>
			<div class="pagination" v-if="items.length >= 10">
				<v-pagination
					v-model="page"
					:color="color"
					:length="getPaginationTotal()"
					:total-visible="$vuetify.breakpoint.xs ? 3: 5"
					circle
				></v-pagination>
				<div class="pagination-text">show</div>
				<div class="pagination-text-page">{{ countPerpage}}/page</div>
				<v-menu offset-y>
					<template v-slot:activator="{ on, attrs }">
						<div v-bind="attrs" v-on="on"><Down class="down"/></div>
					</template>
					<v-list>
						<v-list-item-title v-for="(pageOption, index) in pageOptions" :key="index" class="option-text" @click="onClickOption(pageOption)">
							{{pageOption}}
						</v-list-item-title>
					</v-list>
				</v-menu>
			</div>
		</template>
	</v-data-table>
</template>
<script>
import SortUpDown from '@/components/icons/sort_up_down';
import ShowSearch from '@/components/icons/show_search';
import FirstList from "@/components/icons/first_list";
import Down from '@/components/icons/down';
import TimeSheet from "@/components/icons/timesheet";
import FindTimesheet from "@/components/icons/find_timesheet";
import TaskTimerIcon from "@/components/tasks/task_timer_icon";
import moment from 'moment';
import config from "@/config.js";
import { colorContrastChecker } from '@/common/colorChecker.js';

const FONT_COLOR = '#81CC00';

export default {
	name: 'TaskTable',
	props: {
		headers: {
			type: Array,
			default: () => []
		},
		items: {
			type: Array,
			default: () => []
		},
		color: {
			type: String,
			default: ''
		},
		statuses: {
			type: Array,
			default: () => []
		},
		perpage: {
			type: Number,
			default: 10
		},
		sort: {
			Type: Object,
			default: null
		},
		search: {
			Type: Object,
			default: null
		}
	},
	data() {
		return {
			items_local: this.items,
			items_local_original: this.items,
			page: 1,
			countPerpage: this.perpage,
			pageOptions: config.pageOptions,
			isHover: '',
			current_key: '',
			selected_task_status: this.statuses.map(status => { return status.id }),
			searchValue: '',
			sortByAscent: false,
			status_completed_type: config.status_completed_type,
			edit_visible: 0
		}
	},
	components: {
		SortUpDown,
		ShowSearch,
		FirstList,
		TimeSheet,
		TaskTimerIcon,
		Down,
		FindTimesheet
	},
	watch: {
		items() {
			this.items_local = this.items;
			this.items_local_original = this.items;
		},
		selected_task_status() {
			this.items_local = this.items_local_original.filter(item => {
				return this.selected_task_status.includes(item.status.id);
			});
		}
	},
	mounted() {
		if (this.search) {
			this.searchValue = this.search.value;
			this.onSearch(this.search.key)
		}

		if (this.sort) {
			this.sortByAscent = !this.sort.value;
			this.onSort(this.sort.key);
		}
	},
	computed: {
		indeterminate() {
			return this.items_local.length !== 0 
				&& !this.items_local.every(res => {return res.select === true})
				&& this.items_local.some(res => { return res.select === true});
		},
		allSelect() {
			return this.items_local.length !== 0 &&
				this.items_local.every(res => { return res.select === true});;
		},
		recordingTaskId() {
			return this.$store.state.recording.task_id;
		},
	},
	methods: {
		onRowClick(item) {
			if (this.edit_visible === 0 && item.job_valid) {
				this.$emit('row-click', item);
			}

			if (this.edit_visible !== 0) {
				this.edit_visible = 0;
			}
		},
		onSelectAllChange(value) {
			if (value) {
				this.items_local.forEach(item => {
					item.select = true;
				});
			} else {
				this.items_local.forEach(item => {
					item.select = false;
				});
			}

			const selected_item_tmp = this.items_local.filter(item => { return item.select === true});
			const selected_item = selected_item_tmp.map(s => { return s.id });
			this.$emit('selected', selected_item);
		},
		onCheckboxChange() {
			const selected_item_tmp = this.items_local.filter(item => { return item.select === true});
			const selected_item = selected_item_tmp.map(s => { return s.id });
			this.$emit('selected', selected_item);
		},
		formatDate(date) {
			if(!date) return null;
			return moment(date).format('DD MMM YYYY');
		},
		formatName(name) {
			let display_name = '';
			if (name.includes(',')) {
				const name_arr = name.split(',');
				if (name_arr[1].includes('(')) {
					const name_tmp = name_arr[1];
					const index = name_tmp.indexOf('(');
					const first_name = name_tmp.substring(0, index-1).trim();
					const last_name = name_arr[0].trim();
					display_name = `${first_name} ${last_name} ${name_tmp.substring(index, name_tmp.length)}`;
				} else {
					const first_name = name_arr[1].trim();
					const last_name = name_arr[0].trim();
					display_name = `${first_name} ${last_name}`;
				}
			} else {
				display_name = name;
			}

			return display_name;
		},
		formatColor(background_color) {
			const color_res = colorContrastChecker(background_color);
			return `${color_res}`
		},
		filterItem(item) {
			const result = {};
			for (const [key, value] of Object.entries(item)) {
				if (key !== 'id' && key !== 'isSuggested' && key !== 'job_valid' && key !== 'other_edit') {
					result[key] = value;
				}
			}

			return result;
		},
		startRecording(task_id) {
			this.$store.dispatch('start_recording', { task_id: task_id, started: new Date().getTime() });
		},
		getStatuses(task_id) {
			const statuses_tmp = JSON.parse(JSON.stringify(this.statuses));
			statuses_tmp.forEach(s => {
				if (this.recordingTaskId === task_id && s.type === this.status_completed_type) {
					s['disable'] = true;
				} else {
					s['disable'] = false;
				}
			});
			return statuses_tmp;
		},
		onLogTime(item) {
			if (item.job_valid) {
				this.$emit('log-time', item.id)
			}
		},
		onEditVisible(item) {
			if (!item.job_valid) return;

			this.edit_visible = item.id;
		},
		onUpdateName(task_id, new_name) {
			const params = [];
			const new_name_tmp = new_name === null ? '':new_name;
			params.push('description=' + new_name_tmp);

			let url = `/api/tasks/${task_id}/set_description`;
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}
			
			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, reason } = json;

					if (status == "OK") {
						this.edit_visible = 0;
					} else {
						this.$emit('error', reason);
					}
				})
				.catch((e) => {
					this.$emit('error', e.message);
				})
		},
		onFindTimesheet(task_id) {
			this.$emit('find-ts', task_id);
		},
		onStatusChange(status, task_id) {
			const param = {
				task_id: task_id,
				status_id: status.id,
			};

			this.$emit('status-change', param);
		},
		onCompleted(item) {
			if (!item.job_valid) return;
			this.$emit('complete', item.id);
		},
		onSearch(key) {
			if (this.searchValue.length === 0) return;

			this.current_key = key;
				
			const arr_filter = this._filterKey(this.items_local_original, key, this.searchValue);
			const arr_replace = JSON.parse(JSON.stringify(arr_filter));

			// to hightlight the kewwords
			const regex = new RegExp(this.searchValue, 'gi');
			arr_replace.forEach(arr => {
				if (arr[key]) {
					if ( typeof(arr[key]) === 'object' ) {
						arr[key].code = arr[key].code.replace(regex, (keyword) => {
							return `<font color="${FONT_COLOR}">${keyword}</font>`;
						});
						arr[key].name = arr[key].name.replace(regex, (keyword) => {
							return `<font color="${FONT_COLOR}">${keyword}</font>`;
						});
					} else {
						arr[key] = arr[key].replace(regex, (keyword) => {
							return `<font color="${FONT_COLOR}">${keyword}</font>`;
						});
					}
				}
			});
			this.items_local = arr_replace;

			const search_obj = {
				key: key,
				value: this.searchValue
			};
			this.$emit('search', search_obj);
		},
		onClean() {
			this.searchValue = '';
			this.items_local = this.items_local_original;

			this.$emit('search', null);
		},
		onSort(key) {
			this.sortByAscent = !this.sortByAscent;

			if (key === 'days') {
				this.sortByAscent
					? this._sort_ascent_number(this.items_local, key)
					: this._sort_descent_number(this.items_local, key);
			} else {
				this.sortByAscent
					? this._sort_ascent(this.items_local, key)
					: this._sort_descent(this.items_local, key);
			}

			const sort_obj = {
				key: key,
				value: this.sortByAscent
			};
			this.$emit('sort', sort_obj);
		},
		getPaginationTotal() {
			return Math.ceil(this.items_local.length / this.countPerpage);
		},
		onClickOption(option) {
			this.countPerpage = option;
			this.$emit('perpage', option);
		},
		_sort_ascent(arr, key) {
			arr.sort((a, b) => {
				let valueA = '';
				let valueB = '';
				if (a[key]) {
					valueA = typeof(a[key]) === 'object' ? a[key].display_name.toUpperCase() : a[key].toUpperCase();
				}

				if (b[key]) {
					valueB = typeof(b[key]) === 'object' ? b[key].display_name.toUpperCase() : b[key].toUpperCase();
				}

				if (valueA < valueB) {
					return -1;
				}
				if (valueA > valueB) {
					return 1;
				}

				return 0;
			});
		},
		_sort_descent(arr, key) {
			arr.sort((a, b) => {
				let valueA = '';
				let valueB = '';

				if (a[key]) {
					valueA = typeof(a[key]) === 'object' ? a[key].display_name.toUpperCase() : a[key].toUpperCase();
				} 

				if (b[key]) {
					valueB = typeof(b[key]) === 'object' ? b[key].display_name.toUpperCase() : b[key].toUpperCase();
				}

				if (valueA > valueB) {
					return -1;
				}
				if (valueA < valueB) {
					return 1;
				}

				return 0;
			});
		},
		_sort_ascent_number(arr, key) {
			arr.sort((a, b) => {
				return a[key] - b[key];
			});
		},
		_sort_descent_number(arr, key) {
			arr.sort((a, b) => {
				return b[key] - a[key];
			});
		},
		_filterKey(arr, key, filter) {
			let fliter_Arr = [];
			const filter_UpperCase = filter.toUpperCase();
			fliter_Arr = arr.filter(a => {
				let A = '';
				if (a[key]) {
					if (typeof(a[key]) === 'object') {
						const name = `${a[key].code}-${a[key].name}`;
						A = name.toUpperCase();
					} else {
						A = a[key].toUpperCase();
					}
				} 
				return A.includes(filter_UpperCase);
			});
			
			return fliter_Arr;
		},
	}
}
</script>
<style lang="scss" scoped>
.task-table {
	width: 100%
}
.header-th {
	background: #FAFAFA;
	&:hover {
		background: #EAEAEA;
	}
}
.header-item {
	display: flex;
  flex-flow: row nowrap;
	justify-content: space-between;
  align-items: center;
}
.header-item-text {
	font-family: Roboto;
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
	line-height: 20px;
	color: #192A3E;
	white-space: nowrap;
	text-overflow: ellipsis;
}
.header-th:hover .icon {
	visibility: visible; 
}
.icon-wrap {
	display: flex;
	flex-flow: row nowrap;
	justify-content: center;
	align-items: center;
}
.icon {
	visibility: hidden;
	width: 20px;
  height: 20px;
	&:hover {
		cursor: pointer;
	}
}
.search-box {
	padding: 13px;
	display: flex;
	flex-flow: column nowrap;
	justify-content: center;
	align-items: center;
	background: #FFFFFF;
	border-radius: 4px;
	.search-box-button {
		margin-top: 9px;
		display: flex;
		flex-flow: row nowrap;
		justify-content: space-between;
		align-items: center;
		div {
			display: flex;
			flex-flow: row nowrap;
			justify-content: center;
			align-items: center;
			border-radius: 4px;
			padding: 0 21px;

			font-family: Roboto;
			font-style: normal;
			font-weight: 500;
			font-size: 14px;
			height: 36px;

			&:hover {
				cursor: pointer;
			}
		}
		:first-child {
			border: 1px solid rgba(25, 42, 62, 0.7);
			margin-right: 10px;
			color: rgba(25, 42, 62, 0.7);
		}
		:last-child {
			border: 1px solid #81CC00;
			background: #81CC00;
			color: #FFFFFF;
		}
	}
}
.user-name-text {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 14px;
	line-height: 20px;
	color: #192A3E;
}
.text-box-black {
	&:hover {
		cursor: pointer;
		border: 1px solid rgba(25, 42, 62, 0.3);
		border-radius: 4px;
	}
}
.date-color-suggest {
	color: #82899B;
}
.pagination {
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: center;
	background-color: rgba(25, 42, 62, 0.1);
	.pagination-text {
		font-family: Roboto;
		font-style: normal;
		font-weight: normal;
		font-size: 13px;
		line-height: 16px;
		color: rgba(25, 42, 62, 0.5);
	}
	.pagination-text-page {
		font-family: Roboto;
		font-style: normal;
		font-weight: normal;
		font-size: 13px;
		line-height: 16px;
		color: #192A3E;
		margin: 0 8px;
	}
	.down {
		width: 12px;
		height: 12px;
		margin-top: 10px;
		&:hover {
			cursor: pointer;
		}
	}
}

::v-deep {
	.theme--light.v-select .v-select__selection--comma {
		color: #81CC00;
	}
	.option-text {
		margin: 0 4px;
		font-family: Roboto;
		font-style: normal;
		font-weight: normal;
		font-size: 13px;
		color: #192A3E;
		&:hover {
			cursor: pointer;
		}
	}
	.v-pagination__navigation {
		width: 20px;
		height: 20px;
	}
	.v-pagination__item {
		min-width: 26px;
		height: 26px;
	}
	.v-badge__badge {
		min-width: 14px;
		height: 14px;
	}
}

</style>